import React from 'react';

export default ({ color = '#8E95AA', size = 19 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.767 17.0999V10.6082H13.0628L13.4112 7.90073H10.767V6.2224C10.767 5.43865 10.9808 4.90823 12.1128 4.90823H13.5378V2.48573C13.2924 2.45406 12.4533 2.38281 11.4795 2.38281C9.43701 2.38281 8.03575 3.63365 8.03575 5.92156V7.90073H5.76367V10.6082H8.03575V17.0999H10.767Z"
      fill={color}
    />
  </svg>
);
